/**
 * @file
 * Behaviors for the Search.
 */
!(function(Drupal, $) {
  'use strict';
  /**
   * Setup and attach the Search behaviors.
   *
   * @type {Drupal~behavior}
   */

  Drupal.behaviors.filterBox = {
    attach: function() {
      const $body = $('body');
      const $filterSelector = $body.find('.sidebar.facets');
      const $filterSelectorButton = $body.find(
        '.search__filter-container .mss-btn'
      );
      const $filterSelectorClose = $body.find(
        '.sidebar.facets .close, .sidebar.facets .show-facet-results'
      );

      if ($(window).width() < 1025) {
        // Check if localstorage variable exists to see
        // if we need to open the slideout on load
        if (localStorage.getItem('searchbar') === 'opened') {
          // Open the slideout on load
          $filterSelector.addClass('active opened');
        }

        $filterSelectorButton.on('click', function(e) {
          e.preventDefault();
          $filterSelector.addClass('active');
          $filterSelectorButton.addClass('active');

          // Save the state of the slideout as "opened" as a localstorage variable
          // to keep slideout open after page load for each filter selection.
          // User has to manually close the slideout
          localStorage.setItem('searchbar', 'opened');
        });

        $filterSelectorClose.on('click', function(e) {
          e.preventDefault();
          $filterSelector.removeClass('active opened');
          $filterSelectorButton.removeClass('active');
          $filterSelectorButton.removeClass('opened');

          // Save the state of the slideout as "closed"
          // so slideout stays closed if page reloads on search
          localStorage.setItem('searchbar', 'closed');
        });
      }
    }
  };
})(Drupal, jQuery);
